import React, { useState } from "react";
import { Box, Typography, TextField, Button, Grid, Container, Paper, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import SideBar from "../dashboard admin/components/SideBar"; // Importando o Sidebar
import api from "../../../services/api/api"; // Importe o seu serviço de API para fazer as requisições
import Swal from 'sweetalert2'; // Importando o SweetAlert2

const CreateUserAdmin = () => {
  const [name, setName] = useState(""); // Estado para nome
  const [email, setEmail] = useState(""); // Estado para email
  const [password, setPassword] = useState(""); // Estado para senha
  const [role, setRole] = useState(""); // Estado para role

  // As 4 opções fixas para roles
  const roles = [
    "journalist",
    "publisher",
    "admin",
    "journalist,publisher", // Combinação de roles permitida
  ];

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  // Função para enviar os dados ao backend e criar o usuário
  const handleCreateUser = () => {
    const token = getAuthToken();

    if (!token) {
      Swal.fire({
        icon: 'error',
        title: 'Erro de Autenticação',
        text: 'Token não encontrado. Faça login novamente.',
        confirmButtonColor: '#1cb5e0'
      });
      return;
    }

    // Validação dos campos obrigatórios
    if (!name || !email || !password || !role) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos Obrigatórios',
        text: 'Por favor, preencha todos os campos.',
        confirmButtonColor: '#1cb5e0'
      });
      return;
    }

    // Prepara os dados para enviar
    const userData = {
      name,
      email,
      password,
      role: role === "journalist,publisher" ? ["journalist", "publisher"] : role, // Converte para array se for a combinação de roles
    };

    // Envia a requisição para criar o usuário
    api
      .post("api/users", userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Usuário criado com sucesso!',
          confirmButtonColor: '#1cb5e0'
        }).then(() => {
          // Limpa os campos após confirmação
          setName("");
          setEmail("");
          setPassword("");
          setRole("");
        });
      })
      .catch((error) => {
        console.error("Erro ao criar o usuário:", error);
        
        // Tratamento de erro mais específico
        let errorMessage = "Erro ao criar o usuário.";
        
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Erro ao Criar Usuário',
          text: errorMessage,
          confirmButtonColor: '#1cb5e0'
        });
      });
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      {/* Sidebar */}
      <Box sx={{ width: 250 }}>
        <SideBar />
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1, p: 3 }}>
        <Container maxWidth="lg">
          <Paper sx={{ p: 3, boxShadow: 3, borderRadius: 2 }}>
            <Typography variant="h4" fontWeight="bold" mb={3}>
              Criar Novo Usuário
            </Typography>

            {/* Formulário de Criação de Usuário */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Nome"
                  value={name}
                  fullWidth
                  onChange={(e) => setName(e.target.value)} // Permite a edição do nome
                  sx={{ mb: 2 }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={email}
                  fullWidth
                  onChange={(e) => setEmail(e.target.value)} // Permite a edição do email
                  sx={{ mb: 2 }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Senha"
                  type="password"
                  value={password}
                  fullWidth
                  onChange={(e) => setPassword(e.target.value)} // Permite a edição da senha
                  sx={{ mb: 2 }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Função</InputLabel>
                  <Select
                    label="Função"
                    value={role}
                    onChange={(e) => setRole(e.target.value)} // Atualiza a role selecionada
                  >
                    {roles.map((roleOption) => (
                      <MenuItem key={roleOption} value={roleOption}>
                        {roleOption}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    backgroundColor: "#1cb5e0",
                    "&:hover": {
                      backgroundColor: "#000851",
                    },
                  }}
                  onClick={handleCreateUser} // Chama a função de criação
                >
                  Criar Usuário
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default CreateUserAdmin;